module.exports = __webpack_public_path__ + "static/img/1.da2bde76.png";